export default [{
    path: '/walletConnect',
    name: 'wc',
    component: () => import('@/views/pages/wallet-connect/Index.vue'),
    meta: {
        layout: 'full',
        resource: 'Auth',
        action: 'read'
    },
    children: [
        {
            path: 'registion',
            name: 'wc-registion',
            component: () => import('@/views/pages/wallet-connect/Registration.vue'),
            meta: {
                layout: 'full',
                resource: 'Auth',
                action: 'read'
            }
        },
        {
            path: 'account',
            name: 'wc-account',
            component: () => import('@/views/pages/wallet-connect/Account.vue'),
            meta: {
                layout: 'full',
                resource: 'Auth',
                action: 'read'
            }
        }
    ]
}]
